/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { AmountUnit } from './AmountUnit';
import {
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    AmountUnitToJSONTyped,
} from './AmountUnit';

/**
 * 
 * @export
 * @interface PublicLootBoxRewardPreview
 */
export interface PublicLootBoxRewardPreview {
    /**
     * 
     * @type {RewardType}
     * @memberof PublicLootBoxRewardPreview
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxRewardPreview
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxRewardPreview
     */
    amount?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof PublicLootBoxRewardPreview
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxRewardPreview
     */
    giftCardAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxRewardPreview
     */
    tilloBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxRewardPreview
     */
    assetId?: string;
}



/**
 * Check if a given object implements the PublicLootBoxRewardPreview interface.
 */
export function instanceOfPublicLootBoxRewardPreview(value: object): value is PublicLootBoxRewardPreview {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PublicLootBoxRewardPreviewFromJSON(json: any): PublicLootBoxRewardPreview {
    return PublicLootBoxRewardPreviewFromJSONTyped(json, false);
}

export function PublicLootBoxRewardPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicLootBoxRewardPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'amountUnit': json['amountUnit'] == null ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'tilloBrandName': json['tilloBrandName'] == null ? undefined : json['tilloBrandName'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
    };
}

export function PublicLootBoxRewardPreviewToJSON(json: any): PublicLootBoxRewardPreview {
    return PublicLootBoxRewardPreviewToJSONTyped(json, false);
}

export function PublicLootBoxRewardPreviewToJSONTyped(value?: PublicLootBoxRewardPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'amount': value['amount'],
        'amountUnit': AmountUnitToJSON(value['amountUnit']),
        'giftCardAmount': value['giftCardAmount'],
        'tilloBrandName': value['tilloBrandName'],
        'assetId': value['assetId'],
    };
}

